import { render, staticRenderFns } from "./Advisory.vue?vue&type=template&id=7ec81a86&scoped=true&"
import script from "./Advisory.js?vue&type=script&lang=js&"
export * from "./Advisory.js?vue&type=script&lang=js&"
import style0 from "./Advisory.vue?vue&type=style&index=0&id=7ec81a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec81a86",
  null
  
)

export default component.exports